export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.generalSetting = payload;

  return newState;
};
